import { render, staticRenderFns } from "./vheader.vue?vue&type=template&id=247fee33&scoped=true&"
import script from "./vheader.vue?vue&type=script&lang=js&"
export * from "./vheader.vue?vue&type=script&lang=js&"
import style0 from "./vheader.vue?vue&type=style&index=0&id=247fee33&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247fee33",
  null
  
)

export default component.exports